import { installChunkLoadRecovery } from './lib/chunkLoadRecovery'
// Stale post-deploy index / missing chunk: reload before Sentry and lazy routes
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
// Initialize Sentry error tracking (must be imported before App)
import './lib/sentry'

installChunkLoadRecovery()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
